import { Turpial } from "./turpial";

const calendari18n = ()=> {
    return {
        months: Turpial.$WindowObject?.ContentsAll?.ctn_4hwhZ1.split(',') ?? ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
        monthsShort: Turpial.$WindowObject?.ContentsAll?.ctn_hEGra9.split(',') ?? ['Ene','Feb','Mar','Abr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dic'],
        weekdays: Turpial.$WindowObject?.ContentsAll?.ctn_FS9ZZz.split(',') ?? ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'],
        weekdaysShort: Turpial.$WindowObject?.ContentsAll?.ctn_yaYQow.split(',') ?? ['Dom','Lun','Mar','Mié','Jue','Vie','Sáb'],
        weekdaysAbbrev: Turpial.$WindowObject?.ContentsAll?.ctn_wNyGq_.split(',') ?? ['D','L','M','M','J','V','S']
    }
}

class FormatDate 
{
    /**
     * @returns format: Diciembre 18, 2022
     */
    month_day_year(date){
        date = new Date(date);
        const month = date.toLocaleString('default', { month: 'long' });
        const day = new Date(date).getDate();
        const year = new Date(date).getFullYear();

        return `${month} ${day}, ${year}`
    }

    /**
     * @returns format: 18 de Diciembre de 2022
    */
    full_day_month_year(date, division){
        division = division || "de";
        date = new Date(date);
        const month = date.toLocaleString('default', { month: 'long' });
        const day = new Date(date).getDate();
        const year = new Date(date).getFullYear();

        return `${day} ${division} ${month} ${division} ${year}`
    }
}



export { calendari18n, FormatDate }